import { PRODUCT_IDS } from '@/src/constants/products';
import {
  chargeAnytimeProducts,
  isChargeAnytimeProduct,
} from '@/src/pages/AnytimeEligibilityV2/hooks/useChargeAnytimeBoltonState';
import { BoltonInstance, ProductId } from '@/src/types/Products';
import { ProductsActivated, ProductsUpdate } from '@/src/types/State';

const supportedProducts: Array<ProductId> = [
  PRODUCT_IDS.greenElectricity,
  PRODUCT_IDS.greenGas,
  PRODUCT_IDS.greenBundle,
  PRODUCT_IDS.evBundle,
  PRODUCT_IDS.ovoFoundation,
  PRODUCT_IDS.greenerEnergy,
  PRODUCT_IDS.greenerElectricity,
  ...chargeAnytimeProducts,
];

/**
 * All active products are cancellable
 * PAYD is cancellable if it is initialized
 * @param product
 */
export const isBoltonCancellable = (product: BoltonInstance) => {
  if (!supportedProducts.includes(product.productId)) {
    return false;
  }
  if (product.status === 'Active') {
    return true;
  }
  if (isChargeAnytimeProduct(product.productId)) {
    return product.status === 'Initialized';
  }
  return false;
};

const selector = (
  productsActivated: ProductsActivated,
  cancellation: null | ProductsUpdate,
) => ({
  boltons: productsActivated?.data?.boltons?.filter(isBoltonCancellable) || [],
  bundle:
    productsActivated?.data?.bundle &&
    supportedProducts.includes(productsActivated.data.bundle.productId)
      ? productsActivated.data.bundle
      : undefined,
  cancellationStates: cancellation || {},
  showSuccessMessage: Boolean(
    cancellation &&
      Object.keys(cancellation).some(
        // @ts-ignore yep, object.keys iterates keyof. surprise surprise TS
        (key: keyof ProductsUpdate) =>
          cancellation && cancellation[key] && cancellation[key]!.success,
      ),
  ),
});

export default selector;
